import {
	GetLeveragedTokenTypeGQLService,
	GetLeveragedTokenTypeQuery
} from "../../../../../api/graphql/staking/generated/leveragedTokens.token-type.service.graphql-gen";
import { EMPTY, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { InfoService } from "@core-services/info.service";
import { ExceptionsService } from "@core-services/exceptions.service";
import { Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { ILeverageTokenInfo } from "../entities/leveraged-tokens-state.model";

@Injectable({
	providedIn: "root"
})
export class LeveragedTokensRemote {
	public constructor(
		private readonly leveragedTokenTypeService: GetLeveragedTokenTypeGQLService,
		private readonly infoService: InfoService,
		private readonly exceptionsService: ExceptionsService,
		private readonly apicallService: ApicallService
	) {}

	public fetchLeveragedTokenType$(assetId: string): Observable<GetLeveragedTokenTypeQuery> {
		return this.leveragedTokenTypeService
			.watch({ input: { assetId: assetId } }, { fetchPolicy: "network-only" })
			.valueChanges.pipe(
				map(({ data }) => data),
				catchError(this.exceptionsService.extractGqlErrorAndRethrow),
				catchError((error) => {
					this.infoService.handleApiError(error);
					return EMPTY;
				})
			);
	}

	public fetchLeverageTokenInfo$(assetId: string): Observable<ILeverageTokenInfo> {
		const option = new ApicallOption();
		option.apiVersion = "v2";
		return this.apicallService.get("assets/" + assetId + "/leverage-info", option);
	}
}
